/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Memory_Desc6Inputs */

const en_svc_ai_agent_development_memory_desc6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working, long-term, and semantic memory so the agent learns from every run instead of starting cold each time.`)
};

const ar_svc_ai_agent_development_memory_desc6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذاكرة عاملة وطويلة الأجل ودلالية حتى يتعلم الوكيل من كل تشغيل بدلًا من البدء من الصفر.`)
};

const bn_svc_ai_agent_development_memory_desc6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওয়ার্কিং, দীর্ঘমেয়াদী ও সেম্যান্টিক মেমোরি, যেন এজেন্ট প্রতি রানে শেখে, প্রতিবার শূন্য থেকে শুরু না করে।`)
};

const de_svc_ai_agent_development_memory_desc6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeits-, Langzeit- und semantisches Gedächtnis, damit der Agent aus jedem Lauf lernt, anstatt jedes Mal neu anzufangen.`)
};

const es_svc_ai_agent_development_memory_desc6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memoria de trabajo, a largo plazo y semántica para que el agente aprenda de cada ejecución en lugar de comenzar en frío cada vez.`)
};

const fr_svc_ai_agent_development_memory_desc6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mémoire de travail, à long terme et sémantique pour que l'agent apprenne de chaque exécution au lieu de démarrer à froid à chaque fois.`)
};

const pt_svc_ai_agent_development_memory_desc6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memória de trabalho, de longo prazo e semântica para que o agente aprenda com cada execução, em vez de começar a frio todas as vezes.`)
};

const zh_svc_ai_agent_development_memory_desc6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作、长期和语义记忆，因此代理可以从每次运行中学习，而不是每次都冷启动。`)
};

const tr_svc_ai_agent_development_memory_desc6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çalışan, uzun süreli ve anlamsal bellek sayesinde ajan her seferinde sıfırdan başlamak yerine her çalıştırmadan öğrenir.`)
};

const ru_svc_ai_agent_development_memory_desc6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рабочая, долговременная и семантическая память, позволяющая агенту учиться при каждом запуске, а не каждый раз начинать с нуля.`)
};

const pl_svc_ai_agent_development_memory_desc6 = /** @type {(inputs: Svc_Ai_Agent_Development_Memory_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamięć robocza, długoterminowa i semantyczna, dzięki czemu agent uczy się przy każdym uruchomieniu, zamiast za każdym razem zaczynać na zimno.`)
};

/**
* | output |
* | --- |
* | "Working, long-term, and semantic memory so the agent learns from every run instead of starting cold each time." |
*
* @param {Svc_Ai_Agent_Development_Memory_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_memory_desc6 = /** @type {((inputs?: Svc_Ai_Agent_Development_Memory_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Memory_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_memory_desc6(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_memory_desc6(inputs)
	if (locale === "de") return de_svc_ai_agent_development_memory_desc6(inputs)
	if (locale === "es") return es_svc_ai_agent_development_memory_desc6(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_memory_desc6(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_memory_desc6(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_memory_desc6(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_memory_desc6(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_memory_desc6(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_memory_desc6(inputs)
	return en_svc_ai_agent_development_memory_desc6(inputs)
});
export { svc_ai_agent_development_memory_desc6 as "svc_ai-agent-development_MEMORY_desc" }